<div class = "body">
    
    <div class = "afiliado" *ngIf = "rol == 'ROLE_ADMINISTRADOR' || rol == 'ROLE_CONTABILIDAD' || rol == 'ROLE_ENCARGADO_CONTABILIDAD' || rol == 'ROLE_COORDINADOR'">
  
        <div class = "container" style = "height:100px"> </div>
  
        <div class = "container" id = "tabla" style = "background-color: white; padding-top: 50px; padding-bottom:50px">
  
            <div class = "row">
  
                <div class = "col-lg-6"> <h1> Afiliaciones Pendientes </h1> </div>
                
                <div class = "col-lg-3"> </div>
  
                <div class = "col-lg-2"> <h3> Cantidad de Registros </h3> </div>
  
                <div class = "col-lg-1">
  
                    <select class = "form-control" (change) = "cambiaCantidadRegistros()" [(ngModel)] = "config.itemsPerPage">
          
                        <option value = "10">10</option>
                        <option value = "20">20</option>
                        <option value = "30">30</option>
                        <option value = "50">50</option>
                        <option value = "100">100</option>
                        
                    </select> </div>
  
            </div> <hr/> <br/> 
  
            <div class = "row">
             
                <div class = "col-lg-2"> <h3>  Fecha Afiliación:</h3> </div> 
                                
                <div class = "col-lg-2">
                 
                    <input class = "form-control" [(ngModel)] = "fechaPagoGrupo" type = "date"/>
                
                </div>
  
                <div class = "col-lg-1"> </div>
  
                <div class = "col-lg-3"> <button class = "btn btn-success" (click) = "enviarPostulacionesSeleccionadas()"> 
                    
                    <i class = "fa fa-plus"></i> Aprobar Solicitudes </button> 
            
                </div>
  
  
                <div *ngIf = "this.idProducto==2" class = "col-lg-2"> <h3> Total seleccionado: </h3> </div> 
                                
                <div *ngIf = "this.idProducto==2" class = "col-lg-3">
                    <input class = "form-control"  
                     name = "totalizado" 
                     matInput
                     disabled
                     [(ngModel)]="totalizado"
                     (input)="totalizado()"
                     type="text">    
                                     
                </div>
  
            </div> <br/> <br/> 
           
            <div class = "row">
  
                <div class = "col-lg-4"> 
                    <h3> <mat-checkbox color = "primary" [checked] = "allComplete" [indeterminate] = "someComplete()"
                    (change) = "setAll($event.checked)"> Seleccionar Todo </mat-checkbox> </h3> 
                </div>
            
                <div class = "col-lg-7"> 
                    
                </div>
  
            </div> 
            
            <div class = "table-responsive">
  
                <table class = "table" style = "width:100%;">
                
                    <thead style = "background-color: #0f69b4;color:white;    width:100%;">
                    
                        <tr>
                            <th> </th>
  
                         
                            <th scope = "col" style = "width:15%;"> Rut </th>
  
                            <th scope = "col"> Nombres</th>
  
                            <th scope = "col"> Apellidos </th>
  
                            <th scope = "col"> Correo</th>
                           
                            <th scope = "col"> región </th>
                           
                            <th scope = "col"> Fecha de Ingreso</th>
                          
                        </tr>
  
                    </thead>
                    
                    <tbody>
                       
                        <tr class = "tablaPostulaciones" *ngFor = "let postulacion of postulaciones | paginate: config">
                            
                            <td>
                                <div *ngIf ="this.idProducto==2 else actualizadorTotal">
                                    <mat-checkbox [(ngModel)] = "postulacion.seleccionado" color = "primary" 
                                    (ngModelChange) = "updateAllComplete()"  (change)="actualizaTotal(postulacion)"> </mat-checkbox>
                                </div> 
                                <ng-template #actualizadorTotal>
                                    <mat-checkbox [(ngModel)] = "postulacion.seleccionado" color = "primary" 
                                    (ngModelChange) = "updateAllComplete()"> </mat-checkbox>
                                </ng-template>                             
  
                            </td> 
                          
                            <td> {{postulacion.rut}} </td>
                            
                            <td> {{postulacion.nombre}}  </td>
  
                            <td> {{postulacion.apellidoPaterno}}  {{postulacion.apellidoMaterno}}</td>
                                                
                            <td> {{postulacion.email}} </td>                        
  
                            <td> {{postulacion.region}} </td>  
                           
                            <td> {{postulacion.fechaSolicitud}} </td>
                           
                        
                        </tr>
                    
                    </tbody>
                
                </table> <br/>
  
                <pagination-controls style = "text-align: center" previousLabel = "Anterior" nextLabel = "Siguiente" 
                (pageChange) = "pageChanged($event)" autoHide = "true"> </pagination-controls>
                            
            </div>
  
        </div>
        
        <div class = "container" style = "height:100px"> </div>
    
    </div>
  
  </div>